var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "baseTransparentMaskMain",
      style: {
        opacity: _vm.opacity
      },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.consoleInfo("main click")
        }
      }
    },
    [
      _c("div", { staticStyle: { color: "#ffffff" } }, [
        _vm._v(_vm._s(_vm.prompt))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }